import { render, staticRenderFns } from "./EmailForHost.vue?vue&type=template&id=6904a8cc&"
import script from "./EmailForHost.vue?vue&type=script&lang=ts&"
export * from "./EmailForHost.vue?vue&type=script&lang=ts&"
import style0 from "./EmailForHost.vue?vue&type=style&index=0&id=6904a8cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports